<template>
  <BasePage :pageTitle="__DICT__.tray.contacts" show-menu show-footer>
    <Card margin="" body-class="p-0">
      <div class="list-group list-group-flush">
        <div
            v-for="contact in filteredContacts"
            :key="contact.contactId"
            class="list-group-item"
        >
          <div class="row align-items-center">
            <div class="col">
              <div class="font-weight-medium">{{ contact.contactName }}</div>
            </div>
            <div class="col-auto">
              <div class="btn-list">
                <a
                    v-if="contact.tel"
                    @click="handlePhoneClick(contact.tel)"
                    class="btn btn-icon btn-ghost-primary"
                    title="Call"
                >
                  <IconPhone class="icon" :size="24" />
                </a>
                <a
                    v-if="contact.email"
                    :href="`mailto:${contact.email}`"
                    class="btn btn-icon btn-ghost-primary"
                    title="Email"
                >
                  <IconMail class="icon" :size="24" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card>
    <PhoneNumberActionSheet
        :phone-number="selectedPhoneNumber"
        :is-visible="showActionSheet"
        @close="showActionSheet = false"
    />
  </BasePage>
</template>

<script setup>
import BasePage from "@/components/BasePage.vue";
import { api } from "@/services/api.js";
import { ref, computed, onMounted } from "vue";
import PhoneNumberActionSheet from "@/components/PhoneNumberActionSheet.vue";
import { Card } from "@/components/atomic";
import { IconPhone, IconMail } from '@tabler/icons-vue';

const contacts = ref([]);
const selectedPhoneNumber = ref(null);
const showActionSheet = ref(false);

const fetchContacts = async () => {
  try {
    const response = await api.get('/api/contacts');
    contacts.value = response;
  } catch (error) {
    console.error('Failed to fetch contacts:', error);
  }
};

const handlePhoneClick = (number) => {
  selectedPhoneNumber.value = number
  showActionSheet.value = true
}

const filteredContacts = computed(() => {
  return contacts.value.sort((a, b) => a.contactName.localeCompare(b.contactName));
});

onMounted(() => {
  fetchContacts();
});
</script>